import React, { useEffect, useState, useRef } from "react";
import { PASSWORD_RULES } from "../../../../configs/AppConfig";
import validator from "validator";
import { modifyUserPost } from "../../../../services/UserService";
import { toast } from "react-toastify";
import Utils from "../../../../utils";
import { CustomInput } from "../../../../components";

function ModifyUser(props) {
  const [userId, setUserId] = useState(0);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [roleId, setRoleId] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isShowPasswordContain, setIsShowPasswordContain] = useState(false);
  const [groupType, setGroupType] = useState(1);
  const [groupId, setGroupId] = useState("");
  const [groupName, setGroupName] = useState("");

  const clsModifyUserRef = useRef(null);

  let errorsObj = {
    first_name: "",
    last_name: "",
    email: "",
    role_id: "",
    password: "",
    confirm_password: "",
  };
  const [errors, setErrors] = useState(errorsObj);

  let passwordRuleList = PASSWORD_RULES;
  const [passwordRules, setPasswordRules] = useState(passwordRuleList);

  useEffect(() => {
    setUserId(parseInt(props?.users.id));
    setFirstName(props?.users.first_name || "");
    setLastName(props?.users.last_name || "");
    setEmail(props?.users.email || "");
    setRoleId(props?.users.role_id || "");
  }, [props?.users]);

  const handleCloseModifyUser = (e) => {
    e.preventDefault();

    props.setUsers({
      id: 0,
      first_name: "",
      last_name: "",
      email: "",
      role_id: "",
      role_name: "",
      group_name: "",
      group_ids: [],
    });

    setPassword("");
    setConfirmPassword("");
    setIsShowPasswordContain(false);
    setErrors(errorsObj);

    let passwordList = [...passwordRuleList];
    passwordList.forEach((x) => (x.active = false));
    setPasswordRules(passwordList);

    setGroupId("");
    setGroupName("");
    setGroupType(1);
  };

  const handlePassword = (e) => {
    let value = e.target.value;
    setPassword(value);
    let passwordRule = [...passwordRuleList];

    const isUpper = /^(?=.*[A-Z]).*$/;
    const isLower = /^(?=.*[a-z]).*$/;
    const isNum = /^(?=.*[0-9]).*$/;
    const isSymbol = /^(?=.*[~!@#$%^&]).*$/;

    // Length
    passwordRule[0].active = value.length > 7;

    passwordRule[1].active = isUpper.test(value);
    passwordRule[2].active = isLower.test(value);
    passwordRule[3].active = isNum.test(value);
    passwordRule[4].active = isSymbol.test(value);

    setPasswordRules(passwordRule);
  };

  const handleModifyUser = (e) => {
    e.preventDefault();
    let errorObj = { ...errorsObj };
    let error = false;

    const isSymbol = /^(?=.*[~!@#$%^&]).*$/;

    // VALIDATIONS
    if (!firstName) {
      errorObj.first_name = "First name is required";
      error = true;
    }
    if (!lastName) {
      errorObj.last_name = "Last name is required";
      error = true;
    }
    if (!email) {
      errorObj.email = "Email is required";
      error = true;
    } else if (!validator.isEmail(email)) {
      errorObj.email = "Please enter valid email address";
      error = true;
    }
    if (!roleId) {
      errorObj.role_id = "Please select role";
      error = true;
    }

    // CREATE NEW USER VALIDATION
    if (userId === 0) {
      if (!password) {
        errorObj.password = "Password is required";
        error = true;
      }
      if (password && !isSymbol.test(password)) error = true;

      if (!confirmPassword) {
        errorObj.confirm_password = "Confirm password is required";
        error = true;
      } else if (confirmPassword !== password) {
        errorObj.confirm_password = "Confirm password does not match";
        error = true;
      }
    } else {
      if (password && confirmPassword !== password) {
        errorObj.confirm_password = "Confirm password does not match";
        error = true;
      }
    }

    setErrors(errorObj);
    if (error) return;

    props.setLoading(true);

    let obj = {
      id: userId,
      first_name: firstName,
      last_name: lastName,
      email: email,
      role_id: roleId,
      password: password,
      group_id: groupId,
      group_name: groupName,
    };

    modifyUserPost(obj)
      .then((response) => {
        props.setLoading(false);
        props.setIsCall(!props.isCall);
        toast.success(response.data.message);
        clsModifyUserRef?.current.click();
      })
      .catch((err) => {
        props.setLoading(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleGroupType = (e) => {
    setGroupId("");
    setGroupName("");
    setGroupType(e.target.value);
  };

  return (
    <div className="offcanvas offcanvas-end Add-Recipients" data-bs-scroll="true" tabIndex={-1}
      data-bs-keyboard="false" data-bs-backdrop="static" id="modifyUser" aria-labelledby="modifyUserLabel">
      <div className="setting-offcanvas-header">
        <h5 className="setting-offcanvas-title">
          {userId > 0 ? "Edit User" : "Create User"}
        </h5>

        <button
          type="button"
          className="setting-close-btn"
          data-bs-dismiss="offcanvas"
          ref={clsModifyUserRef}
          onClick={handleCloseModifyUser}
        >
          <i className="bi bi-x-lg"></i>
        </button>
      </div>

      <div className="offcanvas-body">

        <div className="setting-form-grid">

          {/* FIRST NAME */}
          <CustomInput
            label="First Name *"
            name="first_name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            error={errors.first_name}
          />

          {/* LAST NAME */}
          <CustomInput
            label="Last Name *"
            name="last_name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            error={errors.last_name}
          />

          {/* EMAIL */}
          <CustomInput
            label="Email *"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value.trim())}
            error={errors.email}
          />

          {/* ROLE SELECT */}
          <div className="setting-field">
            <label className="setting-label">Role *</label>

            <select
              className="setting-select"
              value={roleId}
              onChange={(e) => setRoleId(e.target.value)}
            >
              <option value="">Select Role</option>
              {props.roleList.map((item, index) => (
                <option key={index} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>

            {errors.role_id && (
              <div className="setting-error">{errors.role_id}</div>
            )}
          </div>
        </div>

        {/* ================= MORE DETAILS ACCORDION ================= */}
        {parseInt(userId) === 0 && (
          <div className="setting-accordion">
            <button
              className="setting-accordion-btn"
              data-bs-toggle="collapse"
              data-bs-target="#MoreDetails"
            >
              More Details
            </button>

            <div id="MoreDetails" className="collapse show">
              <div className="setting-accordion-body">

                {/* RADIO SECTION */}
                <div className="setting-radio-group">
                  <label className="setting-radio">
                    <input
                      type="radio"
                      name="group_type"
                      checked={parseInt(groupType) === 1}
                      value={1}
                      onChange={handleGroupType}
                    />
                    <span>Select Group From List</span>
                  </label>

                  <label className="setting-radio">
                    <input
                      type="radio"
                      name="group_type"
                      checked={parseInt(groupType) === 2}
                      value={2}
                      onChange={handleGroupType}
                    />
                    <span>Add New Group</span>
                  </label>
                </div>

                {/* GROUP SELECT */}
                {parseInt(groupType) === 1 && (
                  <select
                    className="setting-select setting-full"
                    value={groupId}
                    onChange={(e) => setGroupId(e.target.value)}
                  >
                    <option value="">Select Group</option>
                    {props.groupList.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                )}

                {/* ADD NEW GROUP */}
                {parseInt(groupType) === 2 && (
                  <CustomInput
                    label="Group Name"
                    value={groupName}
                    onChange={(e) => setGroupName(e.target.value)}
                  />
                )}
              </div>
            </div>
          </div>
        )}

        {/* PASSWORD FIELDS */}
        <div className="setting-form-grid mt-3">

          <CustomInput
            type="password"
            label="Password *"
            value={password}
            onChange={handlePassword}
            onFocus={() => setIsShowPasswordContain(true)}
            error={errors.password}
          />

          <CustomInput
            type="password"
            label="Confirm Password *"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            error={errors.confirm_password}
          />
        </div>

        {/* PASSWORD RULES */}
        {isShowPasswordContain && (
          <div className="setting-password-rules">
            <p>Password must contain:</p>

            <ul>
              {passwordRules.map((item, index) => (
                <li key={index} className={item.active ? "green" : "red"}>
                  <i className={`fa fa-${item.active ? "check" : "close"}`} />
                  {item.text}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* FOOTER BUTTONS */}
        <div className="modal-footer">
          <button
            type="button"
            className="setting-btn-cancel"
            data-bs-dismiss="offcanvas"
            onClick={handleCloseModifyUser}
          >
            Cancel
          </button>

          <button type="button" onClick={handleModifyUser} className="btn-primary">
            {userId > 0 ? "Update User" : "Create User"}
          </button>
        </div>
      </div>
    </div>

  );
}

export default ModifyUser;
